import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { MatCheckbox } from '@angular/material';
import { Filter, FilterComponentBase } from '../filters/filters';
var NumberFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NumberFilterComponent, _super);
    function NumberFilterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.change = new EventEmitter();
        _this.onChangeCallback = function (_) { };
        return _this;
    }
    NumberFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkbox.change.subscribe(function (e) {
            _this.onChange();
        });
    };
    NumberFilterComponent.prototype.onChange = function () {
        var value = this.checkbox.checked ? this.value : null;
        this.onChangeCallback(value);
        this.change.emit(value);
    };
    NumberFilterComponent.prototype.writeValue = function (value) {
        if (value !== undefined) {
            this.value = value;
        }
    };
    NumberFilterComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    NumberFilterComponent.prototype.registerOnTouched = function (fn) {
        this.checkbox.registerOnTouched(fn);
    };
    return NumberFilterComponent;
}(FilterComponentBase));
export { NumberFilterComponent };
